// extracted by mini-css-extract-plugin
export default {"l_EditRequestTextArea_textareaContainer":"EditRequestTextArea_l_EditRequestTextArea_textareaContainer__76Bcn"};